import React from 'react';
import type { ScheduleStatus } from 'src/types/Schedules';
import styles from './ScheduleStatusPill.module.scss';

interface Props {
  status: ScheduleStatus;
  lastError?: string;
}

export const ScheduleStatusPill: React.FC<Props> = ({ status, lastError }) => {
  const isErrorPaused = status === 'paused' && !!lastError;
  const className = isErrorPaused
    ? styles.error
    : status === 'paused'
    ? styles.paused
    : styles.active;

  return (
    <span className={`${styles.pill} ${className}`}>
      {isErrorPaused ? 'Error' : status === 'active' ? 'Active' : 'Paused'}
    </span>
  );
};
